import { observer } from 'mobx-react';
import ClickableTooltip from '../../../../../../ClickableTooltip';
import { EyeSlashIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../../Translations';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { whenZero } from '@execonline-inc/numbers';

interface Props {
  experienceCount: number;
}

function NoExperiencesIcon({ experienceCount }: Props) {
  return whenZero(experienceCount)
    .map(() => (
      <ClickableTooltip tooltipId={'no-programs'} tooltipIcon={<EyeSlashIcon className="h-5" />}>
        <T kind="0 programs included;..." />
      </ClickableTooltip>
    ))
    .getOrElse(emptyFragment);
}

export default observer(NoExperiencesIcon);
